const SUPPORTED_MIME_TYPES = { 'image/gif': 'gif', 'image/jpeg': 'jpg', 'image/png': 'png' };

export const removeSignature = (text) => text.replace(/-Signature-[\s\S]*/g, '');
export const contentTypeToExtension = (contentType) => SUPPORTED_MIME_TYPES[contentType] || '';

export const downloadBlob = (blob, name) => {
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = name;
  link.dispatchEvent(
    new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window,
    })
  );
  return link;
};
